export enum ClassGroupsEnum {
    ARTS = 'arts',
    BUSINESS = 'business',
    EDUCATION = 'education',
    HEALTH_PROFESSIONS = 'healthProfessions',
    HUMANITIES = 'humanities',
    PROTECTIVE_SERVICES = 'protectiveServices',
    SCIENCE_TECHNOLOGY_MATH = 'scienceTechnologyMath',
    TRADES_SERVICES = 'tradesServices',
}

export enum ClassIDEnum {
    art1 = 'art1',
    art2 = 'art2',
    art3 = 'art3',
    art4 = 'art4',
    art5 = 'art5',
    art6 = 'art6',
    art7 = 'art7',
    art8 = 'art8',
    art9 = 'art9',
    art10 = 'art10',
    art11 = 'art11',
    art12 = 'art12',
    art13 = 'art13',
    art14 = 'art14',
    art15 = 'art15',
    biz1 = 'biz1',
    biz2 = 'biz2',
    biz3 = 'biz3',
    biz4 = 'biz4',
    biz5 = 'biz5',
    biz6 = 'biz6',
    biz7 = 'biz7',
    biz8 = 'biz8',
    edu1 = 'edu1',
    edu2 = 'edu2',
    edu3 = 'edu3',
    edu4 = 'edu4',
    edu5 = 'edu5',
    edu6 = 'edu6',
    edu7 = 'edu7',
    edu8 = 'edu8',
    hlth1 = 'hlth1',
    hlth2 = 'hlth2',
    hlth3 = 'hlth3',
    hlth4 = 'hlth4',
    hlth5 = 'hlth5',
    hlth6 = 'hlth6',
    hlth7 = 'hlth7',
    hlth8 = 'hlth8',
    hlth9 = 'hlth9',
    humn1 = 'humn1',
    humn2 = 'humn2',
    humn3 = 'humn3',
    humn4 = 'humn4',
    humn5 = 'humn5',
    humn6 = 'humn6',
    humn7 = 'humn7',
    humn8 = 'humn8',
    humn9 = 'humn9',
    humn10 = 'humn10',
    humn11 = 'humn11',
    humn12 = 'humn12',
    humn13 = 'humn13',
    humn14 = 'humn14',
    humn15 = 'humn15',
    humn16 = 'humn16',
    humn17 = 'humn17',
    protc1 = 'protc1',
    protc2 = 'protc2',
    protc3 = 'protc3',
    protc4 = 'protc4',
    protc5 = 'protc5',
    protc6 = 'protc6',
    protc7 = 'protc7',
    scnc1 = 'scnc1',
    scnc2 = 'scnc2',
    scnc3 = 'scnc3',
    scnc4 = 'scnc4',
    scnc5 = 'scnc5',
    scnc6 = 'scnc6',
    scnc7 = 'scnc7',
    scnc8 = 'scnc8',
    scnc9 = 'scnc9',
    scnc10 = 'scnc10',
    scnc11 = 'scnc11',
    scnc12 = 'scnc12',
    scnc13 = 'scnc13',
    trad1 = 'trad1',
    trad2 = 'trad2',
    trad3 = 'trad3',
    trad4 = 'trad4',
    trad5 = 'trad5',
    trad6 = 'trad6',
}
